import LoginWrap from 'modules/v2/login/containers/Login';

export default function LoginPage() {
  return <LoginWrap />;
}
